var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.8564 30.9017L48.792 30.9694C48.7619 31.0005 48.7314 31.0314 48.7006 31.0621L31.0382 48.6961C27.9614 51.768 22.9729 51.768 19.8961 48.6961L15.0186 43.8267C14.6728 43.4828 14.6721 42.9236 15.0163 42.5782C15.1176 42.4766 15.2421 42.4012 15.379 42.3584C20.6069 40.7446 24.8548 38.8817 28.1225 36.7699C35.9047 31.7403 42.816 29.7843 48.8564 30.9017ZM45.1535 16.3958C51.6746 18.4507 50.9135 23.2479 51 25.1391C43.8584 21.3943 35.2669 22.7669 25.2254 29.2566C17.741 34.0937 11.4716 36.088 6.4173 35.2395C1.363 34.391 0.226 28.2183 0 26.578C5.5538 29.3861 12.9966 27.7744 22.3283 21.7434C31.024 16.1235 38.6324 14.3409 45.1535 16.3958ZM31.0382 2.30389L35.6212 6.8789C35.9664 7.2233 35.9669 7.7825 35.6225 8.1278C35.4996 8.251 35.3431 8.3351 35.1726 8.3694C28.538 9.706 23.232 11.6596 19.2546 14.2302C12.4389 18.6351 6.6308 20.6825 1.8303 20.3724L1.8308 20.3711L19.8961 2.30389C22.9729 -0.767962 27.9614 -0.767962 31.0382 2.30389Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwell);
export default __webpack_public_path__ + "static/media/SWELL.e3b7e991bdc7417aed38e5cc18239c17.svg";
export { ForwardRef as ReactComponent };